<!-- 保单信息 -->
<template>
  <div>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <div class="title_">
        <div class="cutleft_">保单信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-form-item :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }" label="起止日期">
        <a-date-picker :disabled-date="disabledDate" :disabled="disabledAll" :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }" placeholder="开始日期" v-decorator="['baodanData.startdata', { rules: [{ required: true, message: '请选择起始日期！' }] }]" @change="effectiveDateChange" />
        <a-date-picker :showTime="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }" style="margin-left: 20px" disabled placeholder="结束日期" v-model="applicantInfoExpireDate" />
        <span style="margin-left: 24px" v-if="planOffsetDay > 0">共{{ planOffsetDay }}天</span>
        <a-radio-group v-model="mon" @change="onChangemon">
          <a-radio :disabled="disabledAll" v-for="item in guarantPre" :key="item.key" :value="item.key">{{ item.value }}</a-radio>
        </a-radio-group>
      </a-form-item>
      <div class="title_">
        <div class="cutleft_">投保企业信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-form-item :label-col="{ span: 3 }" label="投保企业名称">
        <a-input :disabled="disabledAll" v-model="applicantInfo.name" v-decorator="['applicantInfo.name', { rules: [{ required: true, message: '请输入投保企业名称' }] }]" @blur="e => checkLength(e.target.value, '40', 'applicantInfo.name')" placeholder="请输入投保企业名称"></a-input>
      </a-form-item>
      <a-row :gutter="24">
        <a-col :span="12" style="padding-left: 12px">
          <a-form-item :label-col="{ span: 6 }" label="行业类别">
            <a-cascader
              :disabled="disabledAll"
              :options="industryList"
              :field-names="{ label: 'text' }"
              :show-search="{ filter }"
              @change="(value, label) => handleChange(value, 'industrycode', label)"
              :fieldNames="{
                label: 'text',
                value: 'value',
                children: 'children'
              }"
              v-decorator="['applicantInfo.industrycode', { rules: [{ required: true, message: '请选择' }] }]"
              placeholder="请选择行业"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保企业证件类型">
            <a-select
              :disabled="disabledAll"
              @change="value => handleChange(value, 'idType')"
              v-decorator="[
                'applicantInfo.idType',
                {
                  rules: [{ required: true, message: '请选择投保企业证件类型' }]
                }
              ]"
              placeholder="请选择投保企业证件类型"
            >
              <a-select-option v-for="item in companyIdTypeOptions" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
					<div class="idNumber-form-item">
						<a-form-item :label-col="{ span: 6 }" label="投保企业证件号码">
							<a-input
								:disabled="true"
								v-model="applicantInfo.idNumber"
								v-decorator="[
									'applicantInfo.idNumber',
									{
										rules: [{ required: true, message: '请输入投保企业证件号码' }]
									}
								]"
								placeholder="请输入投保企业证件号码"
							></a-input>
						</a-form-item>
						<!-- 客服二维码组件 -->
						<customerService></customerService>
					</div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="企业性质">
            <a-select placeholder="请选择" style="width:293px" :disabled="disabledAll" @change="value => handleChange(value, 'enttypecode')" v-decorator="['applicantInfo.enttypecode', { rules: [{ required: true, message: '请选择' }] }]">
              <a-select-option v-for="item in companyPropertyList" :key="item.key" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="企业存续时间" style="margin-left: 10px;">
            <a-select placeholder="请选择" style="width:293px" :disabled="disabledAll" @change="value => handleChange(value, 'expirationDate')" v-decorator="['applicantInfo.expirationDate', { rules: [{ required: true, message: '请选择' }] }]">
              <a-select-option v-for="item in cunxuTimeList" :key="item.key" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :span="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系地址">
            <a-cascader
              :disabled="disabledAll"
              placeholder="请选择"
              style="width:293px"
              @change="(value, label) => handleChange(value, 'pacCode', label)"
              v-decorator="[
                'applicantInfo.pacCode',
                {
                  rules: [{ required: true, message: '请输入省市区' }]
                }
              ]"
              :options="addressOptions"
              :fieldNames="{
                label: 'text',
                value: 'value',
                children: 'children'
              }"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="详细地址" style="margin-left: 10px;">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.address"
              v-decorator="[
                'applicantInfo.address',
                {
                  rules: [{ required: true, message: '请输入联系地址' }]
                }
              ]"
              @blur="e => checkLength(e.target.value, '40', 'applicantInfo.address')"
              placeholder="请输入联系地址"
              style="width:294px"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="企业联系人姓名">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.contactsname"
              v-decorator="[
                'applicantInfo.contactsname',
                {
                  rules: [{ required: true, message: '请输入企业联系人姓名' }]
                }
              ]"
              placeholder="请输入企业联系人姓名"
            ></a-input>
            <p style="font-size: 12px;color: red;">企业联系人应为投保企业授权的保险业务经办人</p>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="企业联系人身份证号">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.medicalcode"
              v-decorator="[
                'applicantInfo.medicalcode',
                {
                  rules: [
                    { required: true, message: '请输入企业联系人身份证号' },
                    { pattern: $regTest.validIdCard, message: '联系人身份证号不正确' }
                  ]
                }
              ]"
              placeholder="请输入企业联系人身份证号"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="企业联系人电话">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.contactsphone"
              v-decorator="[
                'applicantInfo.contactsphone',
                {
                  rules: [
                    { required: true, message: '请输入企业联系人电话' },
                    { pattern: $regTest.checkPhone, message: '联系人电话不正确' }
                  ]
                }
              ]"
              placeholder="请输入企业联系人电话"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="企业联系人邮箱">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.email"
              v-decorator="[
                'applicantInfo.email',
                {
                  rules: [
                    { required: true, message: '请输入企业联系人邮箱' },
                    { pattern: $regTest.checkEmail, message: '联系人邮箱不正确' }
                  ]
                }
              ]"
              placeholder="请输入企业联系人邮箱"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="支付方式">
            <a-select
              :disabled="disabledAll"
              @change="value => handleChange(value, 'payMethod')"
              placeholder="请选择支付方式"
              v-decorator="[
                'applicantInfo.payMethod',
                {
                  rules: [{ required: true, message: '请选择支付方式' }]
                }
              ]"
            >
              <a-select-option v-for="item in payTypeList" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24" v-if="applicantInfo.payMethod === '89'">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="凭证附件上传">
            <a-upload
              name="multipartFile"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="false"
              accept="image/*"
              :before-upload="beforeUploadImg"
              v-decorator="[
                'applicantInfo.uploadSign',
                {
                  rules: [{ required: true, message: '请上传支付凭证图片' }]
                }
              ]"
              @change="handleChangeImg"
            >
              <img v-if="imageUrlUpload" :src="imageUrlUpload" alt="avatar" style="max-width: 300px" />
              <div v-else>
                <a-icon :type="imageUploadLoading ? 'loading' : 'plus'" />
                <div class="ant-upload-text">上传</div>
              </div>
            </a-upload>
          </a-form-item>
        </a-col>
      </a-row>
      <salInsuredList :effectiveDate="applicantInfo.effectiveDate" :disabledAll="disabledAll" :columns="columns" :data="salInsuredList" @delSelect="delSelectpre" @addSelect="addSelectpre" @EduitSelect="eduitSelect"></salInsuredList>

      <!-- 发票信息 -->
      <div class="title_">
        <div class="cutleft_">开票信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-row>
        <a-row>环保节约，提倡电子发票，如需纸质版本，请自行打印，系统将通过邮件及手机短信发送电子发票，请注意查收。</a-row>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 4 }" label="发票类型">
            <a-select :disabled="disabledAll" placeholder="请选择" @change="invoiceprinttypeChange" v-decorator="['applicantInfo.invoiceprinttype', { rules: [{ required: true, message: '请选择' }] }]">
              <a-select-option value="01">暂不开票</a-select-option>
              <a-select-option value="03">电子发票</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12" v-if="applicantInfo.invoiceprinttype == '03'">
          <a-form-item :label-col="{ span: 6 }" label="纳税人识别号">
            <a-input :disabled="disabledAll" v-model="applicantInfo.taxpayercertificateno" v-decorator="['applicantInfo.taxpayercertificateno', { rules: [{ required: true, message: '请输入纳税人识别号' }] }]" placeholder="请输入纳税人识别号"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <div class="title_">
          <div class="cutleft_">总保费</div>
          <div class="cutoff_"></div>
        </div>
        <a-form-item label="保费" :label-col="{ span: 1 }">
          <a-col :span="6">
            <a-input v-model="applicantInfo.totalPremium" disabled style="width: 130px" addonAfter="元" />
          </a-col>
          <a-col v-if="false">
            <a-button class="btn_color" :disabled="disabledAll" type="primary" @click="changePremium">修改保费</a-button>
          </a-col>
        </a-form-item>
      </a-row>

      <a-row :gutter="24" class="btn_list" v-show="disabledAll">
        <div class="title_">
          <div class="cutoff_"></div>
        </div>
        <a-checkbox :disabled="!agreementAllRead" @change="onChangeyueduBtn" style="margin-bottom: 20px">
          投保人已充分阅读、理解并同意
          <fileView></fileView>
        </a-checkbox>
      </a-row>
      <a-row class="order">
        <a-col :span="24">
          <a-form-item :wrapper-col="{ span: 12, offset: 10 }">
            <a-button class="btn_color" type="primary" :loading="submitLoad1" v-show="!disabledAll" @click="handleSubmit">保存订单</a-button>
            <a-button style="margin-left: 24px" class="btn_color" type="primary" v-show="disabledAll" @click="fastInsure">
              立即投保
            </a-button>
            <a-button style="margin-left: 24px" class="btn_color" type="primary" v-show="disabledAll" @click="gonOne">编辑</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <!-- 修改保费modal -->
    <a-modal v-model="modalVisible" title="修改保费" cancelText="取消" okText="确定" @ok="handleOk">
      <div v-for="(item, key) in ContentViewEduit" :key="key">
        <div>
          请输入职业{{ key }}类保费(如不输入则按原值({{ occuLevelSingalPrem[key] }})计算)：
          <a-input-number class="level_" :min="parseFloat(occuLevelSingalPrem[key])" v-model="ContentViewEduit[key]" />
        </div>
      </div>
    </a-modal>
    <!-- 支付的弹窗 -->
    <a-modal class="myModal_" width="500px" title="支付确认" forceRender v-model="showPaySure" @ok="paySure" okText="确定" cancelText="关闭">
      <p
        style="
          text-align: center;
          font-size: 18px;
          margin-bottom: 0;
          padding: 20px;
          line-height: 30px;
        "
      >
        您投保的{{ productName() }}需支付保费 <span style="color: #fe8f2d; font-weight: bold"> {{ applicantInfo.totalPremium }} </span>&nbsp;元
      </p>
    </a-modal>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import moment from 'moment';
import salInsuredList from './salInsuredList';
import { policyMixin } from '@/mixins/policyMixin.js';
import { idNumberMixins } from '@/mixins/idNumberMixins.js';
let DATA = require('../data').default;
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    salInsuredList
  },
  mixins: [policyMixin, idNumberMixins],
  data() {
    //这里存放数据
    return {
      disabledAll: false,
      yueduBtn: false, //阅读中
      submitLoad1: false, //保存中
      submitLoad2: false, //提交中
      showPaySure: false, //支付
      postPolicyData: {}, //要提交的数据
      policyId: '', //支付回来的id
      companyPropertyList: DATA.companyPropertyList,
      cunxuTimeList: DATA.cunxuTimeList, //存续时间
      /**需要的数据开始 */
      applicantInfo: {
        name: '', //投保企业名称
        idType: '', //证件类型
        idNumber: '', //证件号码
        imageUrl: '', //证件图片
        pacCode: '', //省市区
        address: '', //详细地址
        enttypecode: '', //企业性质
        expirationDate: '', //存续时间
        industrycode: [], //行业类别
        contactsname: '', //联系人名称
        medicalcode: '', // 联系人身份证号
        contactsphone: '', //联系人电话
        email: '', // 邮箱
        // beneficiary: "", // 附加被保险人
        remark: '', //备注
        invoiceprinttype: '01', //发票类型
        taxpayercertificateno: '', //纳税人识别号
        payMethod: '', //支付方式
        totalPremium: 0, //总保费
        juvenilesAvgpremuim: 0, //单个保费
        expireDate: '',
        effectiveDate: '', //投保期限
        uploadSign: '' //凭证图片jpg/png
      },
      address: '',
      //表格的头部
      columns: DATA.columns,
      //表格的数据
      salInsuredList: [],
      industrycodeTEXT: '', //四级行业的文本
      occuLevelSingalPrem: {}, //险种类
      //投保人证件类型
      companyIdTypeOptions: DATA.companyIdTypeOptions,
      //投保的天数
      guarantPre: DATA.guarantPre,
      form: this.$form.createForm(this, { name: 'advanced_search' }),
      RiskInfos: {
        riskInfos: [
          {
            riskCode: 'AIGHSB2022CR01', //保障方案选择
            amount: 0,
            dutyCode: 'AIGHSB2022CR01',
            premiumAmt: 0
          },
          {
            riskCode: 'AIGHSB2022CR02', //重症监护病房住院津贴以及猝死
            amount: -1,
            dutyCode: 'AIGHSB2022CR02',
            premiumAmt: 0
          },
          {
            riskCode: 'AIGHSB2022CR03', //意外身故丧葬费用
            amount: -1,
            dutyCode: 'AIGHSB2022CR03',
            premiumAmt: 0
          },
          {
            riskCode: 'AIGHSB2022CR04', //交通工具意外身故/伤残
            amount: -1,
            dutyCode: 'AIGHSB2022CR04',
            premiumAmt: 0
          }
        ],
        salPolicyExt: {
          isworkheightinvolved: 2
        },
        salPolicy: {
          productCode: '', //产品code
          bracket: '1', //保费期限
          planCode: ''
        },
        salPolicyHolder: {
          addfifty: '1', // 测算类型
          stature: 2 //是否高空（2-否，1-是）
        },
        premiumBaseDtoList: [] //人数
      }, //测算的数据
      modalVisible: false, //修改保费的弹窗
      ContentViewEduit: {}, //修改的保费
      creator: '1',
      productCode: '',
      plan: '',
      userParams: '',
      /**需要的数据结束 */
      mon: '1',
      planOffsetDay: 0,
      baodanData: {
        startdata: ''
      },
      startValues: null,
      orderContent: {},
      prohibitedIndustries: ['劳务', '人力资源', '职业介绍', '人才服务', '人才介绍', '企业咨询'], //限制行业
      AGE: 65,
      imageUrlUpload: '', // 支付凭证图片上传
      imageFile: '', // 凭证图片文件
      imageUploadLoading: false
    };
  },
  //监听属性 类似于data概念
  computed: {
    // 投保地址码表
    addressOptions() {
      let dataArr = this.$lodash.cloneDeep(window.addrescode);
      return dataArr;
    },
    // 保险结束日期计算
    applicantInfoExpireDate() {
      let mon = this.mon;
      let date = this.applicantInfo.effectiveDate;
      let t2;
      if (date && mon) {
        t2 = moment(date)
          .add(mon, 'months')
          .subtract(1, 's');
      }
      return t2;
    },
    //行业类别
    industryList() {
      let indust = window.jybgzsfOccDatas.industryLists;
      indust.forEach(e => {
        return e.children.filter(el => {
          return el;
        });
      });
      return indust;
    }
  },
  //监控data中的数据变化
  watch: {
    'applicantInfo.pacCode'(val) {
      sessionStorage.removeItem('pacCode');
      sessionStorage.setItem('pacCode', val[1].value || null);
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$bus.$on('onRiskInfos', data => {
      let strdata = this.$lodash.cloneDeep(data);
      this.RiskInfos.riskInfos = strdata.riskInfos;
      this.RiskInfos.salPolicy = strdata.salPolicy;
      this.RiskInfos.salPolicyExt = strdata.salPolicyExt;
      this.RiskInfos.salPolicyHolder = strdata.salPolicyHolder;
      this.mon = strdata.salPolicy.bracket;
      
      if (this.RiskInfos.premiumBaseDtoList.length) {
        this.resultPremiumSum(this.RiskInfos);
      }
    });
    this.$bus.$on('selectCS', data => {
      this.AGE = data;
    });
  },
  //方法集合
  methods: {
    moment,
    // 产品名称
    productName() {
      return sessionStorage.getItem('productName');
    },
    // 编辑方法
    gonOne() {
      this.disabledAll = false;
      this.$bus.$emit('disabledBus', false);
      let oldPolicyId = this.$route.query.policyId;
      
      sessionStorage.setItem('oldPolicyId', oldPolicyId);
      this.$router.push({
        name: 'xsmeiyatyc',
        query: {
          u: this.$route.query.u,
          p: this.$route.query.p,
          sign: this.$route.query.sign,
          planCode: this.$route.query.planCode
        }
      });
    },
    // 行业类别搜索方法
    filter(inputValue, path) {
      return path.some(option => {
        return option.text.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      });
    },
    // 省市区字段过滤方法
    filterPcode(arr) {
      let str;
      if (arr && arr.length) {
        if (isNaN(parseInt(arr[1]))) {
          str = 'text';
        } else {
          str = 'value';
        }
        if (!str) return;
        try {
          var addressOptions = this.$lodash.cloneDeep(this.addressOptions);
          var oneArr = addressOptions.filter(item => arr[0] == item[str]) || [];
          var twoArr = oneArr[0].children.filter(item => arr[1] == item[str]) || [];
          sessionStorage.setItem('pacCode', twoArr[0].value);
        } catch (error) {
          throw new Error(error);
        }
        return {
          code: [oneArr[0] ? oneArr[0].value : '', twoArr[0] ? twoArr[0].value : ''],
          arrCode: [oneArr[0], twoArr[0]]
        };
      }
    },
    // 投保人拒保关键字过滤方法
    checkLength(value, byteLength, param) {
      if (param == 'applicantInfo.name') {
        this.prohibitedIndustries.forEach(element => {
          if (value.indexOf(element) != -1) {
            this.$message.error(`投保人名称包含拒保关键字，无法投保该产品！`);
            this.form.setFieldsValue({
              applicantInfo: { name: '' }
            });
          }
        });
        this.queryCompanyCodeByName();
      }
    },
    // 查询保单信息
    queryOrderDetails() {
      let parms = {
        policyId: this.$route.query.policyId
      };
      this.$api.queryOrderDetails(parms).then(res => {
        if (res.data.returnCode == 0) {
          if (res.data.content) {
            this.orderContent = res.data.content;
            this.$bus.$emit('busRiskInfos', this.orderContent);
            this.$store.commit('setOrderContent', this.orderContent);
            if (res.data.content.salInsuredList) {
              //被保人清单
              this.salInsuredList = res.data.content.salInsuredList;
              this.salInsuredList.forEach((element, i) => {
                let str = element.birthDate;
                element.occupation = [element.occupationCode.substring(0, 3), element.occupationCode.substring(0, 5), element.occupationCode]; //职业类别代码
                element['index'] = i + 1;
                element['relationship'] = 9;
                if (str.indexOf('-') === -1) {
                  element.birthDate = str.slice(0, 4) + '-' + str.slice(4, 6) + '-' + str.slice(6, 8);
                }
              });
            }
            if (res.data.content.salPolicy) {
              let salPolicy = res.data.content.salPolicy;
              this.applicantInfo.payMethod = salPolicy.payMethod;
              this.policyId = salPolicy.id.toString();
              this.plan = salPolicy.planCode;
              this.applicantInfo.mon = salPolicy.bracket;
              this.mon = salPolicy.bracket;
              this.applicantInfo.juvenilesAvgpremuim = salPolicy.juvenilesAvgpremuim;
              this.creator = salPolicy.creator;
              this.productCode = salPolicy.productCode;
              this.$store.commit('setproductCode', this.productCode);
              let effectiveDate;
              if (this.$route.query.xb) {
                //续保情况下时间处理
                effectiveDate = moment(salPolicy.expireDate).add(1, 'days');
              } else {
                effectiveDate = moment(salPolicy.effectiveDate);
              }
              this.applicantInfo.effectiveDate = moment(effectiveDate).format('YYYY-MM-DD HH:mm:ss');
              this.baodanData.startdata = this.applicantInfo.effectiveDate;
              this.form.setFieldsValue({
                applicantInfo: {
                  ...salPolicy,
                  effectiveDate: moment(effectiveDate).format('YYYY-MM-DD')
                },
                baodanData: {
                  startdata: moment(effectiveDate).format('YYYY-MM-DD')
                }
              });
            }

            if (res.data.content.salPolicyHolder) {
              let salPolicyHolder = res.data.content.salPolicyHolder;
              
              this.applicantInfo.name = res.data.content.salPolicyHolder.name;
              this.applicantInfo.pacCode = this.filterPcode([salPolicyHolder.province, salPolicyHolder.city] || []).arrCode;
              this.address = salPolicyHolder.address;
              this.applicantInfo.invoiceprinttype = salPolicyHolder.invoiceprinttype;
              sessionStorage.setItem('pacCode', salPolicyHolder.city);
              this.$nextTick(() => {
                this.form.setFieldsValue({
                  applicantInfo: {
                    ...salPolicyHolder,
                    pacCode: this.filterPcode([salPolicyHolder.province, salPolicyHolder.city] || []).code,
                    industrycode: salPolicyHolder.industrycode ? [salPolicyHolder.industrycode.slice(0, 1), salPolicyHolder.industrycode.slice(0, 3), salPolicyHolder.industrycode.slice(0, 4), salPolicyHolder.industrycode] : []
                  }
                });
                
              });
            }
            if (res.data.content.salPolicyHolderExt) {
              let salPolicyHolderExt = res.data.content.salPolicyHolderExt;
              this.industrycodeTEXT = salPolicyHolderExt.industryname;
            }
            if (res.data.content.salPolicyExt) {
              let salPolicyExt = res.data.content.salPolicyExt;
              this.RiskInfos.salPolicyExt.occEmpVersion = salPolicyExt.occEmpVersion;
              this.RiskInfos.salPolicyExt.isworkheightinvolved = salPolicyExt.isworkheightinvolved;
            }
            this.salInsuredList = res.data.content.salInsuredList;
            this.RiskInfos.premiumBaseDtoList = this.numResult(res.data.content.salInsuredList); //人员类别，处理成每一类的人数
            this.RiskInfos.salPolicy = {
              ...this.RiskInfos.salPolicy,
              ...res.data.content.salPolicy
            };
            this.RiskInfos.salPolicyHolder = {
              ...this.RiskInfos.salPolicyHolder,
              ...res.data.content.salPolicyHolder
            };
            this.RiskInfos.salPolicyHolder.addfifty = '1';
            this.RiskInfos.riskInfos = res.data.content.riskInfos; //险种信息
            this.resultPremiumSum(this.RiskInfos, 'eduit');

            this.occuLevelSingalPrem = this.handleGztypestr(this.orderContent.salPolicyHolder.gztypestr); //恒定不变的展示用，做限制
            this.ContentViewEduit = this.handleGztypestr(this.orderContent.salPolicyHolder.gztypestr); //用来修改的职业保费
            this.applicantInfo.totalPremium = this.orderContent.salPolicy.totalPremium; //总保费
          }
          
        }
      });
    },
    // 选的总投保人数
    totalNumber() {
      let _DATA = this.$lodash.cloneDeep(this.salInsuredList);
      let copyd = _DATA.filter(e => {
        if (e.occulevel) {
          e.occulevel = e.occulevel.slice(0, 1);
          return true;
        }
        return false;
      });

      let num1_3 = copyd.filter(e => e.occulevel < 5).length;
      let num4_6 = copyd.filter(e => e.occulevel > 4).length;
      return {
        allNumber: parseInt(num1_3 + num4_6),
        num1_3,
        num4_6
      };
    },
    // 处理详情返回的险种、
    handleGztypestr(val) {
      if (!val) return;
      let arr = val.split(';');
      let obj = {};
      for (let i = 0; i < arr.length; i++) {
        obj[i + 1] = arr[i];
      }
      return obj;
    },
    //确认修改
    handleOk() {
      let val = this.allPremiumFun(this.ContentViewEduit);
      this.applicantInfo.totalPremium = val;
      this.modalVisible = false;
    },
    //修改保费按钮
    changePremium() {
      if (JSON.stringify(this.occuLevelSingalPrem) == '{}') {
        this.$message.error('您还没有计算保费');
        return;
      }
      this.modalVisible = true;
    },
    //拼接险种
    flightNumberFun(arr) {
      let strArr = [];
      arr.forEach(e => {
        if (e.amount == 0) {
          strArr.push(e.riskCode);
        }
      });
      return strArr.join(',');
    },
    //统计次数和拼接试算类别数据
    numResult(data) {
      
      var d = [];
      var b = {
        '1': 0,
        '2': 0,
        '3': 0,
        '4': 0,
        '5': 0,
        '6': 0
      };
      data.forEach(e => {
        let levelF = Number(e.occulevel.toString().slice(0, 1));
        if (b[levelF] !== undefined) {
          b[levelF] += 1;
        }
      });
      for (const key in b) {
        var c = {
          occupationKind: '',
          personNum: 0
        };
        c.occupationKind = key;
        c.personNum = b[key];
        d.push(c);
      }
      return d;
    },
    //测算的总价格
    allPremiumFun(data) {
      let numArrHolder = this.numResult(this.salInsuredList).holderNum;
      var resultnum = 0;
      for (const key in numArrHolder) {
        resultnum += this.$accuracy.mul(numArrHolder[key], data[key]);
      }
      
      return resultnum.toFixed(2);
    },
    // 职业code对应职业name方法
    filterName(arr) {
      let Code = this.$lodash.cloneDeep(this.fileCodeContent.level_tree);
      let codeName = this.$tools.filterName(Code, arr[arr.length - 1]);
      return codeName;
    },
    //提交的去重
    unique(arr, attribute) {
      var new_arr = [];
      var json_arr = [];
      for (var i = 0; i < arr.length; i++) {
        if (new_arr.indexOf(arr[i][attribute]) == -1) {
          //  -1代表没有找到
          new_arr.push(arr[i][attribute]); //如果没有找到就把这个name放到arr里面，以便下次循环时用
          json_arr.push(arr[i]);
        }
      }
      return json_arr;
    },
    //过滤人员列表
    filterSalInsuredList(data) {
      let DATA = this.$lodash.cloneDeep(data);
      DATA.forEach(e => {
        if (e['gender'] == '男' || e['gender'] == 'M') {
          e['gender'] = 'M';
        } else {
          e['gender'] = 'F';
        }
        e['relationship'] = 9;
        e['occulevel'] = e.occulevel.toString().slice(0, 1);
        e['occupationName'] = this.filterName(e.occupation);
        return e.occulevel;
      });
      return DATA;
    },
    //拼接字符串
    gztypestrPin() {
      var a = {
        '1': 0,
        '2': 0,
        '3': 0,
        '4': 0,
        '5': 0,
        '6': 0
      };
      for (const key in this.ContentViewEduit) {
        a[key] = this.ContentViewEduit[key];
      }
      let baofei = Object.values(a).join(';'); //修改后的职业保费
      return baofei;
    },
    //试算的接口
    resultPremiumSum(data, type) {
      let copyData = this.$lodash.cloneDeep(data);
      let formData = {
        riskInfos: copyData.riskInfos, //险种信息
        salPolicy: {
          planCode: copyData.salPolicy.planCode || this.$route.query.planCode, //产品计划 （固定值ConstructAccident）
          productCode: this.productCode, //productGroupCode  产品组合代码 （固定值ConstructAccident）
          creator: this.creator,
          bracket: copyData.salPolicy.bracket, //
          flightnumber: this.flightNumberFun(copyData.riskInfos) // 另加的拼接险种的字段
        },
        salPolicyExt: {
          isworkheightinvolved: copyData.salPolicyExt.isworkheightinvolved,
          occEmpVersion: this.fileCodeContent.id
        },
        salPolicyHolder: {
          addfifty: '1', // 测算类型
          stature: copyData.salPolicyHolder.stature, //是否高空（2-否，1-是）
          name: this.applicantInfo.name
        },
        premiumBaseDtoList: copyData.premiumBaseDtoList //人数
      };
      this.$api.calPremiumEmployer(formData).then(res => {
        if (res.data.success) {
          let datas = res.data.content;
          if (type != 'eduit') {
            this.occuLevelSingalPrem = this.$lodash.cloneDeep(datas.occuLevelSingalPrem); //恒定不变的展示用，做限制
            this.ContentViewEduit = this.$lodash.cloneDeep(datas.occuLevelSingalPrem); //用来修改的职业保费
            this.applicantInfo.totalPremium = datas.totalPremium; //总保费
          }
        } else {
          this.$message.error(res.data.returnMsg + '错误');
        }
      });
    },
    invoiceprinttypeChange(value) {
      //发票类型更改
      this.applicantInfo.invoiceprinttype = value;
    },
    //选择天数的
    onChangemon(e) {
      this.mon = e.target.value;
      this.RiskInfos.salPolicy.bracket = this.mon;
      if (this.RiskInfos.premiumBaseDtoList.length) {
        this.resultPremiumSum(this.RiskInfos);
      }
      if (this.applicantInfo.effectiveDate) {
        let end = moment(this.startValues)
          .add(this.mon, 'month')
          .subtract(1, 'days');
        let offsetDay = end.diff(this.startValues, 'days') + 1;
        this.planOffsetDay = offsetDay;
        this.form.setFieldsValue({ expireDate: end });
      }
    },
    //处理时间的
    effectiveDateChange(date1, date) {
      this.applicantInfo.effectiveDate = date;
    },
    //开始时间
    disabledDate(current) {
      return (current && current < moment().endOf('day')) || current > moment().add(30, 'day');
    },
    //支付方式key值为89，需要凭证图片上传
    beforeUploadImg(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error('只能上传图片类型文件');
      }
      const isLt2M = file.size / 1024 / 1024 / 1024 / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error('图片必须小于5M');
      }
      return isJpgOrPng && isLt2M;
    },
    getBase64(img, callback) {
      const reader = new FileReader();
      reader.addEventListener('load', () => callback(reader.result));
      reader.readAsDataURL(img);
    },
    handleChangeImg(info) {
      this.getBase64(info.file.originFileObj, imageUrl => {
        this.imageUrlUpload = imageUrl;
      });
      this.imageFile = info.file.originFileObj;
    },
    //最后的提交
    handleSubmit() {
      
      let ageStatus = true;
      this.salInsuredList.forEach(e => {
        let age = this.$tools.jsGetAge(e.birthDate, moment(this.applicantInfo.effectiveDate).format('YYYY-MM-DD'));
        if (age < 18 || age > this.AGE) {
          this.$message.error(`投保人年龄仅限于16-${this.AGE}周岁，请修改后再试！`);
          ageStatus = false;
          return;
        }
      });
      let peopleNum = this.totalNumber();
      if (!peopleNum.allNumber) {
        this.$message.warning('请先选择投保人');
        return;
      }
      if (peopleNum.num1_3 && peopleNum.allNumber < 3) {
        this.$message.warning('1、2、3类投保人数最少为3人');
        return;
      }
      if (peopleNum.num4_6 && peopleNum.allNumber < 5) {
        this.$message.warning('4、5、6类投保人数最少为5人');
        return;
      }
      if (peopleNum.allNumber > 1000) {
        this.$message.warning('单张保单最高投保人数最多1000人');
        return;
      }
      if (!ageStatus) {
        return;
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          
          let base = this.applicantInfo;
          let UNname = '天津';
          if (UNname.indexOf(values.applicantInfo.name) > -1) {
            this.$message.warning('本产品不承保天津及所辖地区的企业。');
            return;
          }
          
          if (!this.$regTest.checkIdCard(values.applicantInfo.medicalcode)) {
            this.$message.error(`联系人身份证有误，请修改后再试！`);
            return;
          }
          let data = {
            salInsuredList: this.filterSalInsuredList(this.salInsuredList), //表格的数据
            salPolicy: {
              //保单信息
              planCode: this.$route.query.planCode, //产品计划 （固定值ConstructAccident）
              productCode: this.productCode, //productGroupCode  产品组合代码 （固定值ConstructAccident）
              creator: this.creator,
              id: this.policyId,
              // issueDate: moment().format("YYYY-MM-DD HH:mm:ss"), //applyTime  投保时间（当前时间）
              effectiveDate: moment(values.baodanData.startdata).format('YYYY-MM-DD'), //startTime  保单生效时间
              expireDate: moment(this.applicantInfoExpireDate).format('YYYY-MM-DD'), //endTime   保单终止时间
              payMethod: values.applicantInfo.payMethod, //支付方式”
              bracket: this.RiskInfos.salPolicy.bracket, //页面选择的保障期间（几个月就传几，整数）
              totalPremium: base.totalPremium, //totalPremium  总保费
              coverageamount: '', //totalSumInsured  总保额
              remark: values.applicantInfo.remark, //备注
              ordertraceno: '', //"凭证支付时的凭证号",
              flightnumber: this.flightNumberFun(this.RiskInfos.riskInfos) // 另加的拼接险种的字段
            },
            salPolicyExt: {
              occEmpVersion: this.fileCodeContent.id,
              isworkheightinvolved: this.RiskInfos.salPolicyExt.isworkheightinvolved
            },
            salPolicyHolder: {
              //投保人信息
              addfifty: '2', //测算类型
              type: 'C', //固定值
              name: values.applicantInfo.name, //name  投保人名称
              idType: values.applicantInfo.idType, //证件类型
              industrycode: values.applicantInfo.industrycode[3], // 行业类别
              idNumber: values.applicantInfo.idNumber, //certNo   证件号码
              address: values.applicantInfo.address, //详细地址
              enttypecode: values.applicantInfo.enttypecode, //企业性质
              expirationDate: values.applicantInfo.expirationDate, //存续时间
              contactsname: values.applicantInfo.contactsname, //联系人姓名
              medicalcode: values.applicantInfo.medicalcode, // 联系人身份证
              contactsphone: values.applicantInfo.contactsphone, //联系人电话
              telephone: values.applicantInfo.contactsphone, //联系人电话
              email: values.applicantInfo.email, //联系人邮箱
              pacCode: values.applicantInfo.pacCode, //地区code
              province: base.pacCode[0].text, //省
              city: base.pacCode[1].text, //市
              district: '', //区
              addresscode: `${base.pacCode[1].value}`,
              stature: this.RiskInfos.salPolicyHolder.stature, //"是否高空，是：1，否：2，默认2"
              invoiceprinttype: values.applicantInfo.invoiceprinttype, //"发票类型，电子普通发票：01、暂不开票：03",
              taxpayercertificatetype: values.applicantInfo.invoiceprinttype == '01' ? values.applicantInfo.taxpayercertificateno : '01',
              taxpayercertificateno: values.applicantInfo.taxpayercertificateno,
              gztypestr: this.gztypestrPin() /**另加 */
            },
            salPolicyHolderExt: {
              industryname: this.industrycodeTEXT
            },
            riskInfos: this.RiskInfos.riskInfos.filter(item => item.amount != -1)
          };
          
          this.postPolicyData = data;
          // return
          if (this.$route.query.policyId) {
            this.postPolicyData.salPolicy.policyId = this.$route.query.policyId;
          }
          this.submitLoad1 = true;
          this.axiosPolicy(); // 保存订单是 直接保存
        } else {
          this.$message.error('请填写完整提交的数据');
        }
      });
    },
    //立即投保
    fastInsure() {
      if (!this.yueduBtn) {
        this.$message.warning('请确认已充分阅读、理解并同意《保险条款》《投保须知》《责任免除》', 2);
        return;
      }
      this.$store.commit('setLoading', { show: true, text: '核保中...' });
      let data = {
        policyId: this.$route.query.policyId || this.policyId
      };
      this.$api
        .groupUnderwriting(data)
        .then(res => {
          if (res.data.returnCode == '0000') {
            this.submitLoad2 = true;
            //支付方式89的时候，直接进行投保支付
            if (this.applicantInfo.payMethod === '89') {
              this.commevidencePolicy();
            } else {
              this.showPaySure = true;
              this.$store.commit('setLoading', { show: false });
            }
          }
        })
        .catch(() => {
          this.$store.commit('setLoading', { show: false });
        });
    },
    //支付方式89的时候，直接进行
    commevidencePolicy() {
      let policyId = this.$route.query.policyId || this.policyId;
      
      this.loadingBtn = true;
      this.$store.commit('setLoading', {
        show: true,
        text: '支付中...'
      });
      let data = {
        evidenceNo: '',
        policyId
      };
      this.$api
        .publicpayApi(data)
        .then(res => {
          //凭证支付 跳转成功页面
          if (res.data.returnCode == '00') {
            this.$message.success('成功');
            setTimeout(() => {
              // 确保录屏结果页不会和弹框重叠
              this.$router.push({
                path: '/result',
                query: {
                  policyId,
                  u: this.$route.query.u,
									productCode: this.productCode
                }
              });
            }, 500);
          }
        })
        .catch(err => {
          setTimeout(() => {
            this.$router.push({
              path: '/result-fail',
              query: {
                policyId,
                u: this.$route.query.u,
                errorTip: err.data.returnMsg || '服务端异常！'
              }
            });
          }, 500);
        })
        .finally(() => {
          this.loadingBtn = false;
          this.$store.commit('setLoading', { show: false });
        });
    },
    axiosPolicy() {
      //提交保单
      this.$api
        .addPAPolicy(this.postPolicyData)
        .then(async res => {
          if (res.data.returnCode == '00') {
            this.showPaySure = false;
            this.policyId = res.data.content;
            if (!this.policyId) {
              this.$message.error('接口异常，没有返回订单id');
              return;
            }
            
            this.$store.commit('setLoading', { show: true, text: '保存中...' });

            // 支付方式89需要上传支付凭证图片
            if (this.applicantInfo.payMethod === '89') {
              const formData = new FormData();
              formData.append('file', this.imageFile);
              formData.append('policyId', this.policyId);
              await this.$api
                .uploadMeiYaEviForAIG(formData)
                
                .catch(() => {
                  this.$store.commit('setLoading', { show: false });
                });
            }

            this.$api
              .uploadMeiYaFile(this.policyId)
              .then(res => {
                if (res.data.returnCode == '00') {
                  this.$message.success('保存成功！');
                  this.$router.push({
                    name: 'xsmeiyatyc',
                    query: {
                      u: this.$route.query.u,
                      p: this.$route.query.p,
                      sign: this.$route.query.sign,
                      planCode: this.$route.query.planCode,
                      policyId: this.policyId,
                      continuation: '1'
                    }
                  });
                  this.disabledAll = true;
                  this.$bus.$emit('disabledBus', true);
                }
              })
              .finally(() => {
                this.$store.commit('setLoading', { show: false });
              });
          }
        })
        .finally(() => {
          this.submitLoad1 = false;
        });
    },
    //支付确认
    paySure() {
      this.showPaySure = false;
      this.submitLoad1 = false;
      this.submitLoad2 = false;
      this.policyId = this.$route.query.policyId;
      this.$payModal({
        show: true,
        type: 'xsmeiyatyc', //产品类型
        policyId: this.policyId, //产品id
        creator: this.creator, //用户id
        payMethod: this.applicantInfo.payMethod, //支付方式
        productCode: this.$route.query.p, //产品code
        totalPremium: this.applicantInfo.totalPremium, //支付总金额
        name: this.applicantInfo.name
      });
    },
    // 表单控件change方法
    handleChange(value, type, label) {
      if (type == 'industrycode') {
        this.industrycodeTEXT = label ? label[3].text : '';
        this.applicantInfo[type] = value;
      }
      if (type == 'pacCode') {
        this.applicantInfo[type] = label;
        this.address = label.length > 1 ? label[0].text + label[1].text : '';
        sessionStorage.setItem('pacCode', value[1]);
      } else {
        this.applicantInfo[type] = value;
      }
      if (type == 'idType') {
        this.queryCompanyCodeByName();
      }
    },
    // 根据公司名称查询公司code
    queryCompanyCodeByName() {
      if (!this.applicantInfo.idType) {
        return;
      }
      this.queryCompanyIdNumber(this.applicantInfo.name, this.applicantInfo.idType, this.companyIdTypeOptions);
    }
  },
  //生命周期 - 销毁之前
  beforeDestroy() {
    this.$bus.$off('onRiskInfos');
    this.$bus.$off('resultPcontent');
    this.$bus.$off('selectCS');
  }
};
</script>
<style scoped>
.avatar-uploader >>> .ant-upload {
  width: 128px;
  height: 128px;
}

.avatar-uploader >>> .ant-upload img {
  width: 100%;
  height: 100%;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.btn_color {
  margin: 0 20px;
}
</style>
